import * as api from './index';

export function sendNewContactMail(payload) {
    return api.post('/contact', payload);
}
